import { date, getDate, showAlert } from '../../../lib/helpers';
import { editedItem, headers, search, getHeaders, getSearch, getEditedItem } from './attributes';
import { dataListPaymentType, dataListSettlementStatus, dataListTrxReportStatus, dataListTrxType, dataQrMethod, dataQrType, promoCodeFilter, sof, transactionQrMethod } from '../../../store/params';

export default {
  data: () => ({
    currentTab: 'qris',
    listButton: {
      buttonRestart: true,
      buttonDots: true,
      buttonSwitchCh: true,
      buttonDotsExt: [
        {
          link: 'exportExcelParent',
          show: true,
          icon: 'mdi-file-excel',
          title: 'Export to excel',
          voidStatus: true,
        },
      ],
    },
    switchCh: true,
    isFirstLoad: true,
    rangeDateDialog: false,
    options: {},
    view: false,
    show: false,
    dialog: false,
    expanded: [],
    headers,
    filter: {
      trx_datetime: [],
    },
    search,
    editedItem,
    selectedRow: '',
    searchAcquirer: '',
    searchIssuer: '',
    listTrxReportStatus: dataListTrxReportStatus,
    listPaymentType: dataListPaymentType,
    listTrxType: dataListTrxType,
    qrMethod: dataQrMethod,
    qrType: dataQrType,
    dateFormatted: '',
    dateMenu: false,
    editedIndex: -1,
    listSettlementStatus: dataListSettlementStatus,
    listSof: sof,
    filterValue: { trx_datetime: [], payment_type: '', rrn: '', mid: '', bill_num: '', invoice_num: '', status: '', promo_code: '', qr_method: ''},
    submittedFilter: { trx_datetime: [], payment_type: '', rrn: '', mid: '', bill_num: '', invoice_num: '', status: '', promo_code: '', qr_method: ''},
    mId: null,
    searchMerchant: '',
    loadingMerchant: false,
  }),

  computed: {
    filterTabItems() {
      return [
        { label: 'QRIS', value: 'qris' },
        { label: 'CPTS', value: 'cpts' },
      ];
    },
    filterConfig() {
      const isSwitcherDisabled = this.filterValue.payment_type === 'on us';
      
      const baseFilters = [
        { key: 'trx_datetime', type: 'daterange', required: true, props: { label: 'Transaction Date', includeToday: true, limitRangeTo30Days: true } },
        { key: 'payment_type', type: 'select', props: { label: 'Payment Type', items: dataListPaymentType } },
        { key: 'rrn', type: 'textfield', props: { label: 'Reff ID' } },
        { key: 'mid',
          type: 'autocomplete',
          props: {
            label: 'MID',
            items: this.merchantList,
            loading: this.loadingMerchant,
            itemText: 'mid',
            itemValue: 'mid',
            search: this.searchMerchant,
            scopedSlots: {
              item: (props) => `${props.item.mid} - ${props.item.merchant_name}`
            },
          },
        },
        { key: this.isTabCpts ? 'invoice_number' : 'bill_num', type: 'textfield', props: { label: this.isTabCpts ? 'Invoice Number' : 'Bill Number' } },
        { key: 'status', type: 'select', props: { label: 'Status', items: dataListTrxReportStatus } },
      ];
      
      if (!this.isTabCpts) {
        baseFilters.push(
          { key: 'qr_method', type: 'select', props: { label: 'QR Method', items: transactionQrMethod } },
          {
            key: 'promo_code',
            type: 'select',
            props: { label: 'Switcher', items: promoCodeFilter, disabled: isSwitcherDisabled }
          },
        );
      }
      
      return baseFilters;
    },
    merchantList() {
      return this.$store.state.report.merchantList;
    },
    allData() {
      return this.$store.state.report.inputerMerchantTransaction.allData;
    },
    detailData() {
      return this.$store.state.report.inputerMerchantTransaction.item;
    },
    allCategory() {
      return this.$store.state.report.inputerMerchantTransaction.allCategory;
    },
    itemsAcquirer() {
      return this.$store.state.report.inputerMerchantTransaction.allAcquirer;
    },
    itemsIssuer() {
      return this.$store.state.report.inputerMerchantTransaction.allIssuer;
    },
    totalData() {
      return this.$store.state.report.inputerMerchantTransaction.totalData;
    },
    totalPage() {
      return this.$store.state.report.inputerMerchantTransaction.totalPage;
    },
    loading() {
      return this.$store.state.report.inputerMerchantTransaction.loading;
    },
    loadingAcquirer() {
      return this.$store.state.report.inputerMerchantTransaction.loadingAcquirer;
    },
    loadingIssuer() {
      return this.$store.state.report.inputerMerchantTransaction.loadingIssuer;
    },
    flashError: {
      get() {
        return this.$store.state.report.inputerMerchantTransaction.flashError;
      },
      set() {
        this.$store.commit(
          'report/inputerMerchantTransaction/setFlashErrorMessage',
          ''
        );
      },
    },
    flashErrorMessage() {
      return this.$store.state.report.inputerMerchantTransaction.flashErrorMessage;
    },
    /**
     * @returns menentukan apa env filter ch true
     */
    checkFilterCh() {
      return JSON.parse(process.env.VUE_APP_FILTER_CH);
    },
    /**
     * @returns jika env VUE_APP_FILTER_CH true, makan akan sesuai toggle. namun jika tidak, untuk default apakah ch atau bukan dengan env VUE_APP_DB_CH
     */
    checkEnvCh() {
      let filterCh = process.env.VUE_APP_DB_CH;

      if (this.checkFilterCh) {
        const filterOn = process.env.VUE_APP_FILTER_DEFAULT;
        const filterOff = filterOn === 'ch' ? 'sql' : 'ch';
        filterCh = this.switchCh ? filterOn : filterOff;
      }

      return filterCh;
    },
    isTabCpts() {
      return this.currentTab === 'cpts';
    },
  },

  watch: {
    options: {
      handler() {
        if (!this.isFirstLoad) {
          this.getData();
        } else {
          this.$store.commit('report/inputerMerchantTransaction/clearData');
        }
        this.isFirstLoad = false;
      },
      deep: true,
    },

    switchCh: {
      handler() {
        this.clearSearch();
      },
    },
    searchMerchant(val) {
      if (val && val.length >= 3) {
        this.mId = val;
        this.getMerchant();
      } else {
        this.mId = '';
        this.$store.commit('report/clearMerchant');
      }
    },
    'filterValue.payment_type': {
      handler(newVal) {
        if (newVal === 'on us' && this.filterValue.promo_code) {
          this.$set(this.filterValue, 'promo_code', '');
          this.$set(this.search, 'promo_code', '');
        }
      }
    },
    'filterValue.promo_code': {
      handler(newVal) {
        if (newVal && newVal !== '' && this.filterValue.payment_type !== 'off us') {
          this.$set(this.filterValue, 'payment_type', 'off us');
          this.$set(this.search, 'payment_type', 'off us');
        }
      }
    },
  },

  async mounted() {
    this.getAcquirer();
    this.getIssuer();
  },

  methods: {
    handleTabChange(tabData) {
      this.currentTab = tabData.tabValue;
      this.headers = getHeaders(tabData.tabValue);
      this.search = getSearch(tabData.tabValue);
      this.editedItem = getEditedItem(tabData.tabValue);
      this.clearSearch();
    },
    handleFilterSearchInput(payload) {
      const { key, value } = payload || {};
      if (key === 'mid') {
        this.searchMerchant = value;
      }
    },
    handleFilterValueChange(payload) {
      const { key, value } = payload || {};
      if (key === 'payment_type') {
        this.$set(this.filterValue, 'payment_type', value);
        this.$set(this.search, 'payment_type', value);
        if (value === 'on us') {
          this.$set(this.filterValue, 'promo_code', '');
          this.$set(this.search, 'promo_code', '');
        }
      } else if (key === 'promo_code') {
        this.$set(this.filterValue, 'promo_code', value);
        this.$set(this.search, 'promo_code', value);
        if (value && value !== '') {
          this.$set(this.filterValue, 'payment_type', 'off us');
          this.$set(this.search, 'payment_type', 'off us');
        }
      } else if (key === 'invoice_num') {
        this.$set(this.filterValue, 'invoice_num', value);
        this.$set(this.search, 'invoice_num', value);
      } else if (key === 'bill_num') {
        this.$set(this.filterValue, 'bill_num', value);
        this.$set(this.search, 'bill_num', value);
      } else {
        this.$set(this.filterValue, key, value);
        this.$set(this.search, key, value);
      }
    },
    getMerchant() {
      this.loadingMerchant = true;
      this.$store.commit('report/setFlashErrorMessage', '');
      this.$store
        .dispatch('report/getMerchant', {
          date,
          sortBy: 'ID',
          search: { mid: this.mId },
          source: 'merchant',
        })
        .then(() => {
          this.loadingMerchant = false;
        });
    },
    getTooltipMethod(item) {
      const descriptions = {
        mpm: 'Merchant Presented Mode',
        cpm: 'Customer Presented Mode',
        qristap: 'QRIS NFC',
        cpts: 'Consumer Present Token Secure',
        'qris tap - single': 'Single Tap Mode',
        'qris tap - tap out': 'Tap Out Finalization Mode',
        'qris tap - tap out without completion': 'Tap Out Without Completion Mode'
      };
      const jenis = item.qr_method?.toLowerCase() || '';
      return descriptions[jenis] || '';
    },
    getTooltipPayement(item) {
      const descriptions = {
        'on us': 'Transaksi pembayaran dalam jaringan BNI',
        'off us': 'Transaksi pembayaran diluar jaringan BNI'
      };

      const jenis = item.payment_type?.toLowerCase() || '';
      return descriptions[jenis] || '';
    },
    updateSearchValues(newSearch) {
      let paymentType = newSearch.payment_type || '';
      let promoCode = newSearch.promo_code || '';
      
      if (paymentType === 'on us') {
        promoCode = '';
      } else if (promoCode && promoCode !== '') {
        paymentType = 'off us';
      }
      const fields = ['trx_datetime', 'rrn', 'mid', 'bill_num', 'status', 'qr_method'];
      fields.forEach(field => {
        const value = field === 'trx_datetime' ? (newSearch[field] || []) : (newSearch[field] || '');
        this.$set(this.search, field, value);
        this.$set(this.filterValue, field, value);
      });
      this.$set(this.search, 'payment_type', paymentType);
      this.$set(this.search, 'promo_code', promoCode);
      this.$set(this.filterValue, 'payment_type', paymentType);
      this.$set(this.filterValue, 'promo_code', promoCode);
    },

    updateSearch(newSearch) {
      this.updateSearchValues(newSearch);
      this.submittedFilter = JSON.parse(JSON.stringify(this.filterValue));
      this.options.page = 1;
      this.getData();
    },

    showType(newSearch) {
      this.updateSearchValues(newSearch);
      this.submittedFilter = JSON.parse(JSON.stringify(this.filterValue));
      this.options.page = 1;
      this.getData();
    },
    handleSwitch(val) {
      this.switchCh = val;
    },
    selectRow(index) {
      if (this.selectedRow !== index) {
        this.selectedRow = index;
      } else {
        this.selectedRow = '';
      }
    },
    getData() {
      if (this.search.trx_datetime.length < 1) {
        this.$vuetify.goTo(0);
        showAlert(
          this.$store,
          'Transaction date is required !',
          'mdi-alert',
          'red'
        );
        this.$store.commit('report/inputerMerchantTransaction/clearData');
      } else {
        const source = this.checkEnvCh;

        this.$store.commit(
          'report/inputerMerchantTransaction/setFlashErrorMessage',
          ''
        );
        const { page, itemsPerPage } = this.options;
        this.$store
          .dispatch('report/inputerMerchantTransaction/getData', {
            date,
            page,
            itemsPerPage,
            search: this.search,
            source,
            tabType: this.currentTab,
          })
          .then(() => {
            if (this.totalPage < page) {
              if (this.totalPage === 0) {
                this.options.page = 1;
              } else {
                this.options.page = this.totalPage;
              }
            }
          });
      }
    },

    getAcquirer() {
      this.$store.dispatch('report/inputerMerchantTransaction/getAcquirer', {
        date,
      });
    },

    getIssuer() {
      this.$store.dispatch('report/inputerMerchantTransaction/getIssuer', {
        date,
      });
    },

    async viewItem(itemId) {
      await this.$store
        .dispatch('report/inputerMerchantTransaction/getDetail', {
          id: itemId,
          date,
          tabType: this.currentTab,
        })
        .then(() => {
          if (!this.loading && this.detailData != null) {
            this.editedIndex = itemId;
          }
          this.editedItem = { ...this.detailData };
          this.view = true;
          this.editedIndex = -2;
          this.dialog = true;
        });
    },
    close() {
      this.view = false;
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = { ...this.defaultItem };
        this.editedIndex = -1;
      });
    },

    closeFlash() {
      this.$store.commit('report/inputerMerchantTransaction/setFlashErrorMessage', '');
    },

    clearSearch() {
      const fields = ['trx_datetime', 'payment_type', 'rrn', 'mid', 'status', 'bill_num', 'invoice_num', 'promo_code', 'qr_method'];
      fields.forEach(field => {
        const value = field === 'trx_datetime' ? [] : '';
        this.$set(this.search, field, value);
        this.$set(this.filterValue, field, value);
      });

      this.submittedFilter = JSON.parse(JSON.stringify(this.filterValue));

      this.$nextTick(() => {
        this.$store.commit('report/inputerMerchantTransaction/clearData');
        this.$store.commit('report/clearMerchant');
      });
    },

    getDate,

    exportExcel() {
      if (this.totalData < 1) {
        this.$vuetify.goTo(0);
        showAlert(this.$store, 'Data is empty !', 'mdi-alert', 'red');
        this.$store.commit('report/inputerMerchantTransaction/clearData');
      } else {
        const { page, itemsPerPage } = this.options;
        const module = this.isTabCpts ? 'cpts-trx-inputer' : 'merchant-trx-inputer';
        const source = this.isTabCpts ? 'mysql' : this.checkEnvCh;

        this.$store.dispatch('exportExcel', {
          date,
          page,
          itemsPerPage,
          sortBy: ['trx_datetime'],
          sortDesc: [true],
          search: this.submittedFilter,
          countData: this.totalData,
          module,
          exportUrl: 'export/generate-export-file/index',
          exportController: 'export/get-export-file',
          sourceData: source,
        });
      }
    },

    exportItem() {
      if (this.totalData < 1) {
        this.$vuetify.goTo(0);
        showAlert(this.$store, 'Data is empty !', 'mdi-alert', 'red');
        this.$store.commit('report/inputerMerchantTransaction/clearData');
      } else {
        const { page, itemsPerPage, sortBy, sortDesc } = this.options;

        this.$store.dispatch('exportList', {
          date,
          page,
          itemsPerPage,
          sortBy,
          sortDesc,
          search: this.search,
          exportUrl: 'api/v1/export/export-inputer-transaction/merchant',
          exportController: 'export-inputer-transaction',
        });
      }
    },
  },

  beforeRouteLeave(to, from, next) {
    this.clearSearch();
    next();
  },
};